//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogContent from './dialogContent.vue';

export default {
  components: { DialogContent },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: 'dialog',
    },
  },
  computed: {
    display: {
      get() {
        return this.value;
      },
      set(payload) {
        this.$emit('change', payload);
      },
    },
  },
};
